<template>
  <v-dialog v-model="dialog" persistent max-width="450px">
    <v-card grid-list-md>
      <v-card-title class="text-h5">Edit Attachment </v-card-title>
      <v-divider></v-divider> 
      <v-card-text class="mt-5">
        <v-row>
          <v-col cols="12" sm="12">
            <v-text-field
              outlined
              :hide-details="nameErrors.length === 0"
              dense
              @keyup.enter="submit"
              :error-messages="nameErrors"
              v-model="Attachment.name"
              label="Name"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close()">Close</v-btn>
        <v-btn color="purple" :loading="loading" text @click="submit()"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AttachmentService from "../service.js";
import _ from "lodash";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false
    },
    editAttachment: {
      type: Object
    }
  },
  name: "update-Attachment",
  data() {
    return {
      loading: false,
      dialog: false,
      Attachment: {
        name: null
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    Attachment: {
      name: {
        required
      }
    }
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.Attachment.name.$dirty) return errors;
      if (!this.$v.Attachment.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    }
  },
  watch: {
    editDialog(val) {
      this.Attachment = _.clone(this.editAttachment)
      this.dialog = val;
    }
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Attachment = {
        name: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.error("Invalid Fields", {
          timeout: 2000,
        });
      } else {
        this.loading = true;
        this.Attachment.name = this.Attachment.name.charAt(0).toUpperCase() + this.Attachment.name.slice(1)
        return AttachmentService.update(this.Attachment.id, this.Attachment)
          .then(result => {
            if (result.status) {
              this.$toast.success("Attachment is updated", {
                timeout: 2000,
              });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch(err => {
            this.loading = false;
            this.$toast.error(err.data ? err.data.message : "Error", {
              timeout: 2000,
            });
          });
      }
    }
  }
};
</script>

<style scoped></style>
